import {
  Grid,
  TextField,
  Button,
  Typography,
  IconButton,
  Card,
  styled,
  Collapse,
  CardHeader,
  CardContent,
} from "@material-ui/core";
import ExpandMore from "@material-ui/icons/ExpandMore";
import useCustomState from "../../hooks/State";
import { Autocomplete } from "@material-ui/lab";
import Call from "../../service/API";
import { UpdateProjectsList } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { cities } from "../../utils/const";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import "../../assets/css/calendar.css";
import { utils } from "react-modern-calendar-datepicker";
import moment from "jalali-moment";
import { useEffect } from "react";
import AddLogo from "./AddLogo";
import Swal from "sweetalert2";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const getDate = (days, prevOrNext) => {
  let date;
  if (prevOrNext == "Prev") {
    date = moment().add(-Number(days), "day");
  } else {
    date = moment().add(Number(days), "day");
  }

  date = date.locale("fa").format("YYYY/MM/DD");
  const jsonDate = {
    year: Number(date.split("/")[0]),
    month: Number(date.split("/")[1]),
    day: Number(date.split("/")[2]),
  };

  return jsonDate;
};

const showDate = (date) => {
  return date.year + "/" + date.month + "/" + date.day;
};

const AddProject = (props) => {
  const expanded = useCustomState(true);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user.permissions.includes("Base")) {
      allowRender.handleChange(true);
    }
  }, []);

  const allowRender = useCustomState(false);

  const projectName = useCustomState("");
  const projectLocation = useCustomState({ title: "", id: -1 });
  const projectDescription = useCustomState("");
  const selectedDate = useCustomState(utils("fa").getToday());
  const employerName = useCustomState("");
  const employerLastName = useCustomState("");
  const employerPhoneNumber = useCustomState("");
  const contractNumber = useCustomState("");
  const logoUrl = useCustomState("");
  const projectNameError = useCustomState({ error: false, text: "" });
  const projectLocationError = useCustomState({ error: false, text: "" });
  const selectedDateError = useCustomState({ error: false, text: "" });

  const changeLogo = (url) => {
    logoUrl.handleChange(url);
  };

  const projectNameChanged = (e) => {
    projectNameError.handleChange({ error: false, text: "" });
    projectName.handleChange(e.target.value);
  };

  const projectLocationChanged = (e, newValue) => {
    projectLocationError.handleChange({ error: false, text: "" });
    projectLocation.handleChange(newValue);
  };

  const projectDescriptionChanged = (e) => {
    projectDescription.handleChange(e.target.value);
  };

  const projectDateChanged = (newDate) => {
    selectedDateError.handleChange({ error: false, text: "" });
    selectedDate.handleChange(newDate);
  };

  const employerNameChanged = (e) => {
    employerName.handleChange(e.target.value);
  };

  const employerLastNameChanged = (e) => {
    employerLastName.handleChange(e.target.value);
  };

  const employerPhoneNumberChanged = (e) => {
    employerPhoneNumber.handleChange(e.target.value);
  };

  const contractNumberChanged = (e) => {
    contractNumber.handleChange(e.target.value);
  };

  const dispatch = useDispatch();

  const addProject = (e) => {
    let hasError = false;
    const name = projectName.value;
    const location = projectLocation.value;
    let date = selectedDate.value;
    const empName = employerName.value;
    const empLastName = employerLastName.value;
    const empPhoneNumber = employerPhoneNumber.value;
    let contNumber = contractNumber.value;
    if (name.length === 0) {
      projectNameError.handleChange({
        error: true,
        text: "واردکردن نام پروژه الزامی است.",
      });
      hasError = true;
    }
    if (location.title.length === 0 || location.id === -1) {
      projectLocationError.handleChange({
        error: true,
        text: "انتخاب محل انجام پروژه الزامی است.",
      });
      hasError = true;
    }

    if (!(date.year && date.month && date.day)) {
      date = null;
    } else {
      date = moment(showDate(date), "jYYYY/jM/jD")
        .locale("utc")
        .format("YYYY-MM-DDT00:00:00Z");
    }
    if (contNumber.length === 0) {
      contNumber = 0;
    }

    if (hasError) {
      return;
    }
    const info = {
      description: projectDescription.value,
    };
    const employerInfo = {
      name: empName,
      lastName: empLastName,
      phoneNumber: empPhoneNumber,
    };
    const projectData = {
      water_meter_project_name: name,
      water_meter_project_title: location.title,
      water_meter_project_other_information: info,
      water_meter_project_start_date: date,
      water_meter_project_employer_description: employerInfo,
      water_meter_project_contract_number: contNumber,
      water_meter_project_images: [],
      water_meter_project_urls: { logo: logoUrl.value, gallery: [] },
    };

    Call("POST", "WaterMeterProjectsURL/admin/add", projectData)
      .then((response) => {
        if (response.data.code === 200) {
          dispatch(UpdateProjectsList({ updateProjectsList: true }));
          Swal.fire({
            toast: true,
            showCancelButton: false,
            title: `پروژه جدید با موفقیت اضافه شد`,
            timer: 4000,
            icon: "success",
            position: "top-start",
            timerProgressBar: true,
          });
          projectName.handleChange("");
          projectLocation.handleChange({ title: "", id: -1 });
          projectDescription.handleChange("");
          selectedDate.handleChange(utils("fa").getToday());
          contractNumber.handleChange("");
          employerName.handleChange("");
          employerLastName.handleChange("");
          employerPhoneNumber.handleChange("");
        }
      })
      .catch((error) => {
        if (error.response) {
          Swal.fire({
            toast: true,
            showCancelButton: false,
            title: "در ایجاد پروژه خطایی رخ داده است",
            timer: 4000,
            icon: "danger",
            position: "top-start",
            timerProgressBar: true,
          });
        }
      });
  };

  // render regular HTML input element
  const inputRenderer = ({ ref }) => (
    <TextField
      aria-readonly={true}
      ref={ref}
      value={convertNumbers(showDate(selectedDate.value))}
      fullWidth
      variant="standard"
      label="تاریخ شروع پروژه"
      InputLabelProps={{
        style: {
          fontFamily: "Vazir",
        },
      }}
      size="small"
    ></TextField>
  );

  if (allowRender.value) {
    return (
      <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
        <Grid item sx={12} sm={12} md={12} lg={12}>
          <Card
            style={{ width: "100%", marginTop: "16px", overflow: "visible" }}
          >
            <CardHeader
              style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
              title={"افزودن پروژه جدید"}
              action={
                <ExpandMoree
                  expand={expanded.value}
                  onClick={handleExpandClick}
                  aria-expanded={expanded.value}
                  aria-label="show more"
                >
                  <ExpandMore />
                </ExpandMoree>
              }
            />
            <Collapse in={expanded.value} timeout="auto" unmountOnExit>
              <CardContent
                style={{
                  padding: "16px",
                  overflow: "visible",
                }}
              >
                <Grid
                  container
                  style={{ paddingTop: "24px", paddingBottom: "24px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                      borderBottom: "1px solid #000",
                      paddingBottom: "16px",
                    }}
                  >
                    <Typography style={{ fontWeight: "bold" }}>
                      اطلاعات پروژه
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                      paddingBottom: "16px",
                    }}
                  >
                    <AddLogo changeLogo={changeLogo} logoUrl={logoUrl.value} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <TextField
                      error={projectNameError.value.error}
                      helperText={projectNameError.value.text}
                      onChange={projectNameChanged}
                      value={convertNumbers(projectName.value)}
                      fullWidth
                      variant="standard"
                      label="نام پروژه"
                      InputLabelProps={{
                        style: {
                          fontFamily: "Vazir",
                        },
                      }}
                      size="small"
                    ></TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <Autocomplete
                      onChange={projectLocationChanged}
                      value={projectLocation.value}
                      options={cities}
                      getOptionLabel={(option) => option.title}
                      id="disable-close-on-select"
                      // disableCloseOnSelect
                      renderInput={(params) => (
                        <TextField
                          error={projectLocationError.value.error}
                          helperText={projectLocationError.value.text}
                          {...params}
                          label="محل انجام پروژه"
                          variant="standard"
                        />
                      )}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                      paddingLeft: "5%",
                      paddingRight: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <DatePicker
                      value={selectedDate.value}
                      onChange={projectDateChanged}
                      renderInput={inputRenderer}
                      colorPrimary="#0eca2d" // added this
                      calendarClassName="custom-calendar" // and this
                      calendarTodayClassName="custom-today-day" // also this
                      shouldHighlightWeekends
                      locale="fa"
                      maximumDate={getDate(30, "Next")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <TextField
                      onChange={contractNumberChanged}
                      value={contractNumber.value}
                      fullWidth
                      variant="standard"
                      label="شماره قرارداد"
                      InputLabelProps={{
                        style: {
                          fontFamily: "Vazir",
                        },
                      }}
                      size="small"
                    ></TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <TextField
                      onChange={projectDescriptionChanged}
                      value={convertNumbers(projectDescription.value)}
                      fullWidth
                      variant="filled"
                      label="توضیحات پروژه"
                      multiline
                      rows={8}
                      maxRows={12}
                      InputLabelProps={{
                        style: {
                          fontFamily: "Vazir",
                        },
                      }}
                      size="small"
                    ></TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                      borderBottom: "1px solid #000",
                      paddingBottom: "16px",
                    }}
                  >
                    <Typography style={{ fontWeight: "bold" }}>
                      اطلاعات کارفرما
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <TextField
                      onChange={employerNameChanged}
                      value={employerName.value}
                      fullWidth
                      variant="standard"
                      label="نام کارفرما"
                      InputLabelProps={{
                        style: {
                          fontFamily: "Vazir",
                        },
                      }}
                      size="small"
                    ></TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <TextField
                      onChange={employerLastNameChanged}
                      value={employerLastName.value}
                      fullWidth
                      variant="standard"
                      label="نام خانوادگی کارفرما"
                      InputLabelProps={{
                        style: {
                          fontFamily: "Vazir",
                        },
                      }}
                      size="small"
                    ></TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <TextField
                      onChange={employerPhoneNumberChanged}
                      value={employerPhoneNumber.value}
                      fullWidth
                      variant="standard"
                      label="شماره تماس"
                      InputLabelProps={{
                        style: {
                          fontFamily: "Vazir",
                        },
                      }}
                      size="small"
                    ></TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      paddingRight: "5%",
                      paddingLeft: "5%",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <Button
                      onClick={addProject}
                      style={{ color: "#fff" }}
                      variant="contained"
                      color="primary"
                    >
                      افزودن
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Collapse>
          </Card>
        </Grid>
      </Grid>
    );
  } else {
    return null;
  }
};

export default AddProject;
